var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 210,
    viewBox: "0 0 210 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210 105c0 57.99-47.01 105-105 105S0 162.99 0 105 47.01 0 105 0s105 47.01 105 105zM9.45 105c0 52.771 42.78 95.55 95.55 95.55 52.771 0 95.55-42.779 95.55-95.55 0-52.77-42.779-95.55-95.55-95.55C52.23 9.45 9.45 52.23 9.45 105z",
    fill: "#054C70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105 0a105 105 0 0 1 105 105h-9.45A95.547 95.547 0 0 0 105 9.45V0z",
    fill: "#05C3DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/Spinner.4e05a4c6ee41cf47d50228274ffe17d3.svg";
export { ForwardRef as ReactComponent };